import Vue from "vue";
//模块功能：船舶动态跟踪查询
export default Vue.extend({
    name: "ship-track",
    data: function () {
        return {};
    },
    mounted: function () {
    },
    methods: {},
    computed: {
        content: function () {
            return this.$t('productsdetail.track');
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/iview-loader??ref--0-1!./src/sfc/product/ship-track.vue
// module id = null
// module chunks = 